import { Component } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { ModalController } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { WideLayoutComponent } from '@examdojo/layout';

@Component({
  selector: 'dojo-submit-confirmation-dialog',
  template: `
    <div class="flex flex-col p-6">
      <div class="aligner mx-auto mb-4 mt-2 h-[135px] w-[135px] p-3">
        <img
          src="assets/images/challenge/timing.svg"
          alt="'challenge_submit_popup.finish_and_submit_early_title' | transloco"
        />
      </div>
      <h3 class="text-display-xs text-primary mb-2 text-center font-semibold">
        {{ 'challenge_submit_popup.finish_and_submit_early_title' | transloco }}
      </h3>
      <p class="text-secondary text-md mb-6 text-center">
        {{ 'challenge_submit_popup.submit_early_warning_1' | transloco }}
      </p>
      <p class="text-secondary text-md mb-9 text-center">
        {{ 'challenge_submit_popup.submit_early_warning_2' | transloco }}
      </p>
      <div class="flex flex-col gap-3">
        <dojo-button (click)="finishAndSubmit()">
          {{ 'challenge_submit_popup.finish_and_submit' | transloco }}</dojo-button
        >
        <wide-layout>
          <dojo-button (click)="keepWorking()" [fill]="'outline'" [customColor]="'sky'">
            {{ 'challenge_submit_popup.keep_working' | transloco }}
          </dojo-button>
        </wide-layout>
      </div>
    </div>
  `,
  styles: [
    `
      ::ng-deep ion-modal.submit-confirmation-dialog {
        @media only screen and (min-width: 768px) {
          --width: 480px;
        }
      }
    `,
  ],
  imports: [ButtonComponent, TranslocoPipe, WideLayoutComponent],
})
export class SubmitConfirmationDialogComponent {
  constructor(private readonly modalController: ModalController) {}

  keepWorking() {
    this.modalController.dismiss(false);
  }

  finishAndSubmit() {
    this.modalController.dismiss(true);
  }
}
